module.exports = __webpack_public_path__ + "static/media/008.ac0e2bd4.jpg";